import { z, ZodIssueCode } from 'zod'

import { MECHANICAL_INFORMATION_FORM_FIELDS } from './constant'
import { BusAuthorizedStatus, UsedTranzauraValue } from '@/types/mechanicalInformation'

const timePattern = /^(?:[01]\d|2[0-3]):[0-5]\d$/

export const schema = z
    .object({
        [MECHANICAL_INFORMATION_FORM_FIELDS.usedTranzaura]: z.nativeEnum(UsedTranzauraValue).optional(),
        [MECHANICAL_INFORMATION_FORM_FIELDS.contactTimeDetails]: z.string().optional(),
        [MECHANICAL_INFORMATION_FORM_FIELDS.engineeringStatement]: z.string().optional(),
        [MECHANICAL_INFORMATION_FORM_FIELDS.busAuthorizedStatus]: z.nativeEnum(BusAuthorizedStatus).optional(),
        [MECHANICAL_INFORMATION_FORM_FIELDS.timeCleared]: z.string().optional(),
        [MECHANICAL_INFORMATION_FORM_FIELDS.bonnetNumber]: z.string().optional(),
        [MECHANICAL_INFORMATION_FORM_FIELDS.substitutionTime]: z.string().optional(),
    })
    .superRefine((data, ctx) => {
        if (data[MECHANICAL_INFORMATION_FORM_FIELDS.busAuthorizedStatus] === BusAuthorizedStatus.BusAuthorized) {
            const timeCleared = data[MECHANICAL_INFORMATION_FORM_FIELDS.timeCleared]

            if (timeCleared && !timePattern.test(timeCleared)) {
                ctx.addIssue({
                    path: [MECHANICAL_INFORMATION_FORM_FIELDS.timeCleared],
                    code: ZodIssueCode.custom,
                    message: 'Invalid time. Please use the 24-hour format HH:MM (e.g., 14:30).',
                })
            }

            return
        }

        if (data[MECHANICAL_INFORMATION_FORM_FIELDS.busAuthorizedStatus] === BusAuthorizedStatus.SubstitutionRequired) {
            const bonnetNumber = data[MECHANICAL_INFORMATION_FORM_FIELDS.bonnetNumber]
            const substitutionTime = data[MECHANICAL_INFORMATION_FORM_FIELDS.substitutionTime]

            if (bonnetNumber && !bonnetNumber) {
                ctx.addIssue({
                    path: [MECHANICAL_INFORMATION_FORM_FIELDS.bonnetNumber],
                    code: ZodIssueCode.custom,
                    message: 'Bonnet number must be provided.',
                })
            }

            if (substitutionTime && !timePattern.test(substitutionTime)) {
                ctx.addIssue({
                    path: [MECHANICAL_INFORMATION_FORM_FIELDS.substitutionTime],
                    code: ZodIssueCode.custom,
                    message: 'Invalid time. Please use the 24-hour format HH:MM (e.g., 14:30).',
                })
            }

            return
        }
    })

export type FormValuesType = z.infer<typeof schema>
